import React from "react";
import { getUser } from "../Utils/Common";
import { useNavigate, Link } from "react-router-dom";
import "./homepage.css";

function Home() {
  const user = getUser();
  const navigate = useNavigate();

  const handleMove = () => {
    if (!user) {
      return navigate("/login");
    } else {
      return window.location.reload(navigate("/account"));
    }
  };

  const handleRedirect = () => {
    window.location.reload(navigate("/lingostory"));
  };

  return (
    <>
      <div className="banner">
        <div className="banner-text">
          <div className="fs-1 text-white text-center">
            <p className="text-center text-white fw-bolder">
              Your first book <br /> &#38; audiobook for free
            </p>
            <button
              onClick={() => handleMove()}
              className="white-btn"
              type="button"
            >
              Try it 0.00 $
            </button>
          </div>

          <div className="mt-10 text-center">
            <p className="fs-1 text-center text-white fw-bolder">
              $9.99 a month after 30 days. <br /> Cancel anytime.{" "}
            </p>
            <Link onClick={handleRedirect} className="white-btn" to={`#`}>
              Browse
            </Link>
          </div>
          <p className="text-center text-white "> conditions of use</p>
        </div>
        <div className="footer-text">
          <p className="fs-2hx text-end text-white fw-bolder">
            The interesting and effective way to learn a language
          </p>
        </div>
      </div>
    </>
  );
}

export default Home;
